import { i18nActions } from './i18n/actions';
import * as types from './types';
import { AuthenticationService } from '../../services/authentication.service';
import router from '../../router';
import { NotificationService } from '../../dt-plugins/notification/notification.service';
import { accountActions } from './account/actions';
import { RequestService } from "../../services/request.service"
import { dtGPTActions } from './dtgpt/actions';
export const actions = {
  ...accountActions,
  async [types.EXPAND_NAV_DRAWER]({ commit }) {
    commit(types.SET_NAV_DRAWER, true);
  },
  async [types.TOGGLE_SIDE_NAV]({ commit }) {
    commit(types.TOGGLE_SIDE_NAV);
  },
  async [types.MINIMIZE_NAV_DRAWER]({ commit }) {
    commit(types.SET_NAV_DRAWER, false);
  },
  async [types.CLIP_NAV_DRAWER]({ commit }) { },
  async [types.UNCLIP_NAV_DRAWER]({ commit }) { },

  async [types.DELETE_SIDE_NAV_ITEM]({ commit, rootState }, tab) {
    commit(
      types.SET_APP_NAV_ITEMS,
        rootState.app.appNavItems.map((module) => {
            if (module.route == "distribution") {
                return {
                    ...module,
                    children: module.children.map((sub) => {
                        if (sub.route == "reports") {
                            return {
                                ...sub,
                                children: sub.children.filter(c => c.route !== tab.route),
                            };
                        } else {
                            return sub;
                        }
                    }),
                };
            } else {
                return module;
            }
        }),
        { root: true }
    );
    console.log('rootState', rootState)
},
  //global Actions
  async [types.FETCH_REQUEST_COUNT]({ commit }) {

    const data = await RequestService.getRequestCount();
    //console.log('types.FETCH_REQUEST_COUNT', data.data);

    commit(types.SET_REQUEST_COUNT, {
      module: 'booking',
      submodule: 'requests',
      value: data.data.count_bookings_requests
    })



    // div v-if = "sitem.badge"

  },

  // Login Actions



  async [types.LOGIN]({ commit, getters }, payload) {

    // console.log(getters.loginUser);

    commit(types.SET_LOGIN_USER, {
      loading: true
    })
    AuthenticationService.login(getters.loginUser).then(res => {

      // Login Successful
      // console.log('Login Successful', res);

      commit(types.SET_LOGIN_USER, {
        // password: [...getters.loginUser.password].map(l => 'B').join(''),
        loading: false,
        success: true
      });


      // commit(types.SET_LOGIN_REDIRECT_ROUTE, { name: 'root' });
      console.log({ "getters.loginRedirectRoute": getters.loginRedirectRoute });

      router.push({
        name: getters.loginRedirectRoute.name,
        params: getters.loginRedirectRoute.params,
        query: getters.loginRedirectRoute.query,
      })

      AuthenticationService.logoutSharedUser();
      
    }).catch(e => {
      if (e.message === 'Request failed with status code 403') {
        commit(types.SET_LOGIN_USER, {
          username: '',
          password: '',
          loading: false,
          success: false
        });
        NotificationService.showNotification({
          text: 'Username or password is incorrect',
          timeout: 5000,
          type: 'error'
        });
      }
      if (e.message === 'Network Error') {
        commit(types.SET_LOGIN_USER, {
          username: '',
          password: '',
          loading: false,
          success: false,
        });
        NotificationService.showNotification({
          text: 'Network Error',
          timeout: 5000,
          type: 'error'
        });
      }
    })

  },
  async [types.SET_LOGIN_REDIRECT_ROUTE]({ commit }, payload) {
    commit(types.SET_LOGIN_REDIRECT_ROUTE, payload);
  },

  async [types.LOGOUT]({ commit }, payload) {
    const logoutResult = await AuthenticationService.logout();
    console.log(logoutResult);

    window.location.reload();
    // const redirectResult = await AuthenticationService.redirectStart();
    // console.log(redirectResult);
  },



  ...i18nActions,
  ...dtGPTActions,
};


